import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  press: css`
    label: press;
    margin-bottom: ${spacing.S};
    ${mq(Breakpoints.TABLET)} {
      margin-bottom: 0;
    }
  `,
  item: css`
    label: press__item;
    // override script setting inline-block
    display: inline-flex !important;
    flex-direction: column;
    padding: 0 ${spacing.XXS};
    text-align: center;
  `,
  copy: css`
    label: press__copy;
    flex: 1 0 5rem;
    color: ${colours.font.DARK_GRAY};
  `,
  imageWrapper: css`
    label: press__imageWrapper;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 3rem;
  `,
  image: css`
    label: press__image;
    max-width: 16rem;
    max-height: 3rem;
    margin: 0 auto;
  `,
  kit: css`
    label: press__kit;
    margin-top: ${spacing.L};
    text-align: center;

    ${mq(Breakpoints.TABLET)} {
      margin-top: ${spacing.S};
    }
  `,
};

export default styles;
